import React, { useEffect, useState } from "react";
import CardFavoris from "../../components/CardFavoris";
import { useDispatch, useSelector } from "react-redux";
import { fetchFavoris } from "../../store/slices/favorisSlice";
import AccountLayout from "../../blocs/AccountLayout";
import { addToFavorites } from "../../store/slices/favorisSlice";
import LoadPic from "../../assets/images/blue-loading-gif-transparent.gif";
import FavorisPageSkeleton from "../../components/skeletons/FavorisPageSkeleton";
import { useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { slugify } from "../../utils/utils";

function FavorisPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { favorites, status, error } = useSelector((state) => state.favorites);
  const [idF, setIdf] = useState();
  // console.log("favorites:", favorites);
  const handleAddToFavorites = async (id) => {
    setIdf(id);
    try {
      const resultAction = await dispatch(addToFavorites(id));
      setIdf(-1);
    } catch (error) {
      // console.error("Erreur inattendue :", error);
      setIdf(-1);
    }
  };
  // Charger les favoris au montage
  useEffect(() => {
    dispatch(fetchFavoris());
  }, []);

  return (
    <>
      <AccountLayout>
        <HelmetProvider>
          <Helmet>
            <title>Mes favoris </title>
            <meta
              name="description"
              content="Page mes etablissements favoris"
            />
          </Helmet>
        </HelmetProvider>
        <h3 className="pd-bt-24">Favoris</h3>
        {status === "loading" && favorites.length === 0 ? (
          <FavorisPageSkeleton />
        ) : (status === "succeeded" && favorites.length > 0) ||
          (status === "loading" && favorites.length > 0) ? (
          <div className="row">
            {favorites.map((favoris, index) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-24">
                <CardFavoris
                  iconImmediat={favoris?.immediat}
                  key={index}
                  name={favoris?.nom}
                  profession={favoris?.activite?.name}
                  rating={favoris?.average_rating}
                  reviews={favoris?.reviews_count}
                  address={favoris?.adresse_postale}
                  services={favoris?.lieu_intervention}
                  photos={favoris?.photos}
                  className={"card"}
                  pic={
                    favoris?.id === idF ? (
                      <img
                        src={LoadPic}
                        className="icon-button"
                        alt="Favorite"
                      />
                    ) : (
                      <img
                        src="/images/favorisHeart.svg"
                        className="icon-button"
                        alt="Favorite"
                      />
                    )
                  }
                  onAddToFavorites={() => handleAddToFavorites(favoris?.id)}
                  onClick={() =>
                    navigate(`/etablissement/${favoris?.slug}`,{state:{idEtablissement:favoris?.id}})
                    // navigate(`/etablissement/${favoris?.id}`, {
                    //   replace: true,
                    // })
                  }
                />
              </div>
            ))}
          </div>
        ) : status === "succeeded" && favorites.length === 0 ? (
          <div className="row"></div>
        ) : null}
      </AccountLayout>
    </>
  );
}
export default FavorisPage;
